import React, {useEffect, useState} from 'react';
import css from './SeoArticle.module.css';
import clsx from "clsx";
import Box from "@mui/material/Box";
import SeoArticleApi from "./SeoArticle.api";
import Typography from "@mui/material/Typography";

export const SeoArticle = (
    {}
) => {
    const [articles, setArticles] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchArticles = async () => {
            const seoArticleApi = new SeoArticleApi();
            try {
                const data = await seoArticleApi.articles();
                console.log(data);
                setArticles(data);
            } catch (error) {
                console.error("Błąd podczas pobierania artykułów:", error);
            }
        };

        if (!isLoaded) {
            setIsLoaded(true);
            fetchArticles();
        }

    }, []);

    let articleNr = 0;
    const articleMain = () => {
        return articleNr++ === 0;
    };

    return (

        articles.length > 0 && (
            <Box className={clsx(css.seoArticle, 'apla')}>
                {articles.map(article => (
                    <Box key={article.key} className={clsx(css.article)}>
                        <Typography className={clsx(css.title)} variant={articleMain() ? "h4" : "h6"}>
                            {article.key}
                        </Typography>
                        <Typography className={clsx(css.content)} variant="body1">
                            {article.textValue1}
                        </Typography>
                    </Box>
                ))}
            </Box>
        )
    )
}